import { useState } from 'react';

import { MenuItem } from '@mui/material';

import { TextField } from 'components/TextField';
import { UserRoles, UserStates } from 'services/api';
import SearchInput from 'src/components/SearchInput';
import { TableFilterRow } from 'src/components/TableList';

import { EmployeeListingFilterProps } from './types';

export const EmployeeListingFilter = ({
  onPageChange,
  params,
  departments
}: EmployeeListingFilterProps): JSX.Element => {
  const handleSearch = (value: string) => {
    onPageChange({ search: value || undefined, offset: undefined });
  };

  const [selectedDepartmentFilter, setSelectedDepartmentFilter] = useState(
    params.departments || ''
  );
  const [selectedStatusFilter, setSelectedStatusFilter] = useState(
    params.status || ''
  );
  const [selectedRolesFilter, setSelectedRolesFilter] = useState(
    params.roles || ''
  );

  return (
    <TableFilterRow>
      <SearchInput
        onSearch={handleSearch} // todo: pass search query param as value
        placeholder={'Search for employee names or emails'}
        sx={{ width: '200%' }}
        value={params.search as string | ''}
      />
      <TextField
        select
        id="department"
        name="departments"
        label="Department"
        value={selectedDepartmentFilter}
      >
        {departments.map((dept) => (
          <MenuItem
            key={dept.id}
            value={dept.id}
            onClick={() => {
              if (selectedDepartmentFilter == dept.id.toString()) {
                setSelectedDepartmentFilter('');
                onPageChange({ ['departments']: undefined });
              } else {
                setSelectedDepartmentFilter(dept.id.toString());
                onPageChange({ ['departments']: dept.id.toString() });
              }
            }}
          >
            {dept.name}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        id="status"
        name="status"
        label="Status"
        value={selectedStatusFilter}
      >
        {Object.entries(UserStates)
          .filter(([_, value]) => value !== UserStates.Suspended)
          .map(([key, value]) => (
            <MenuItem
              key={value}
              value={value}
              onClick={() => {
                if (selectedStatusFilter == value.toString()) {
                  setSelectedStatusFilter('');
                  onPageChange({ ['status']: undefined });
                } else {
                  setSelectedStatusFilter(value.toString());
                  onPageChange({ ['status']: value.toString() });
                }
              }}
            >
              {key}
            </MenuItem>
          ))}
      </TextField>
      <TextField
        select
        id="roles"
        name="roles"
        label="Roles"
        value={selectedRolesFilter}
      >
        {Object.entries(UserRoles).map(([key, value]) => (
          <MenuItem
            key={value}
            value={value}
            onClick={() => {
              if (selectedRolesFilter == value.toString()) {
                setSelectedRolesFilter('');
                onPageChange({ ['roles']: undefined });
              } else {
                setSelectedRolesFilter(value.toString());
                onPageChange({ ['roles']: value.toString() });
              }
            }}
          >
            {key}
          </MenuItem>
        ))}
      </TextField>
    </TableFilterRow>
  );
};
